/**
 * <tp-counter data-value="300" data-duration="1600">0</tp-counter>
 *
 * Web Component em light DOM (sem Shadow DOM) — mantém o número como
 * texto normal, herdando o CSS da section. Anima de 0 até data-value
 * quando o elemento entra perto da viewport, uma única vez.
 *
 * data-value aceita decimais com vírgula ou ponto ("2,4" / "2.4"); o número
 * de casas decimais digitado é mantido e exibido com vírgula.
 */
class TpCounter extends HTMLElement {
  connectedCallback() {
    var rawValue = String(this.dataset.value || '0').trim().replace(',', '.');
    var decimalPart = rawValue.split('.')[1];

    this.targetValue = parseFloat(rawValue) || 0;
    this.decimals = decimalPart ? decimalPart.length : 0;
    this.duration = parseInt(this.dataset.duration, 10) || 1600;
    this.hasAnimated = false;

    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      this.textContent = this.format(this.targetValue);
      return;
    }

    this.textContent = this.format(0);
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.2
    });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  format(number) {
    return number.toFixed(this.decimals).replace('.', ',');
  }

  handleIntersect(entries) {
    var self = this;
    entries.forEach(function (entry) {
      if (entry.isIntersecting && !self.hasAnimated) {
        self.hasAnimated = true;
        self.animate();
        self.observer.disconnect();
      }
    });
  }

  animate() {
    var self = this;
    var start = null;
    var from = 0;
    var to = this.targetValue;

    function step(timestamp) {
      if (start === null) start = timestamp;
      var elapsed = timestamp - start;
      var progress = Math.min(elapsed / self.duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      self.textContent = self.format(from + (to - from) * eased);

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        self.textContent = self.format(to);
      }
    }

    requestAnimationFrame(step);
  }
}

if (!customElements.get('tp-counter')) {
  customElements.define('tp-counter', TpCounter);
}
